import React from "react";
import { Box, Button, Typography } from "@mui/material";

import { Alert, AlertTitle } from "fond/project/panels/InputDataPanel.styles";

interface ReplaceDataConfirmationProps {
  message: string;
  onCancel(): void;
  onReplace(): void;
}

/**
 * Confirmation that proceeding with an option replaces existing data.
 */
const ReplaceDataConfirmation: React.FC<ReplaceDataConfirmationProps> = ({ message, onCancel, onReplace }) => (
  <Alert severity="info">
    <AlertTitle>Replace data</AlertTitle>
    <Typography variant="body3" component="p" mb={1}>
      {message}
    </Typography>
    <Box display="flex" justifyContent="flex-end" gap={1}>
      <Button size="small" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="contained" size="small" onClick={onReplace}>
        Replace
      </Button>
    </Box>
  </Alert>
);

export default ReplaceDataConfirmation;
